<wf-district-report-container [reportTitle]="'District Dashboard'" [loadError]="loadError" (onTour)="startTour()">
  <!-- Report filter ng-content: Filter bar: District / School -->
  <div report-filter>
    <div *ngIf="currentUser?.isFILUser()" class="print-hide">
      <wf-school-teacher-filter
        [error]="schoolFilterError"
        [districts]="districts"
        [schools]="schools"
        [teachers]="teachers"
        [showTeacher]="false"
        (filterChangeEvent)="filterSchoolTeacher($event)"
      ></wf-school-teacher-filter>
    </div>
  </div>

  <!-- Top summary cards -->
  <div class="summary-cards">
    <div class="summary-card">
      <fa-icon [icon]="schoolsIcon" class="summary-icon" style="color: #0054A6 ;"></fa-icon>
      <div class="summary-divider"></div>
      <div class="summary-text">
        <div class="summary-value">{{ numSchools }}</div>
        <div class="summary-label">Schools</div>
      </div>
    </div>
    <div class="summary-card">
      <fa-icon [icon]="teachersIcon" class="summary-icon" style="color: #80C342 ;"></fa-icon>
      <div class="summary-divider"></div>
      <div class="summary-text">
        <div class="summary-value">{{ numTeachers }}</div>
        <div class="summary-label">Teachers</div>
      </div>
    </div>
    <div class="summary-card">
      <fa-icon [icon]="studentsIcon" class="summary-icon" style="color: #0095DA ;"></fa-icon>
      <div class="summary-divider"></div>
      <div class="summary-text">
        <div class="summary-value">{{ numStudentsEnrolled }}</div>
        <div class="summary-label">Students Enrolled</div>
      </div>
    </div>
  </div>

  <!-- Bottom (engagement) section -->
  <div class="engagement-section">
    <div class="login-range print-hide">
      <label for="login-range" class="accent-text">Login date range</label>
      <select id="login-range" name="login-range" [(ngModel)]="dateRange" (change)="loadRangeData()">
        <option *ngFor="let range of dateRanges" [ngValue]="range">{{ range.rangeDisplay }}</option>
      </select>
    </div>
    <!-- Row: School Engagement + Teacher Usage -->
    <div class="engagement-row">
      <!-- School Engagement -->
      <div class="dashboard-card" id="school-engagement-card">
        <div class="card-head">
          <div class="card-title">School Engagement</div>
          <div class="card-top-title school-color">Top School Engagement</div>
        </div>
        <div class="card-body gauge-card">
          <div class="gauge half">
            <canvas baseChart [data]="schoolGaugeData" [options]="gaugeOpts" [type]="gaugeType"></canvas>
            <div class="gauge-center">
              <div class="gauge-value">{{ schoolsMeetingGoal }} of {{ totalSchools }}</div>
              <div class="gauge-caption">Schools with at least<br>60 minutes usage per week</div>
            </div>
          </div>
          <ol class="top-list">
            <li *ngFor="let school of topSchoolEngagement">{{ school.value }}% - {{ school.name }}</li>
          </ol>
        </div>
      </div>

      <!-- Teacher Usage -->
      <div class="dashboard-card" id="teacher-usage-card">
        <div class="card-head">
          <div class="card-title">Teacher Usage</div>
          <div class="card-top-title teacher-color">Top Teacher Logins by School</div>
        </div>
        <div class="card-body gauge-card">
          <div class="gauge half">
            <canvas baseChart [data]="teacherGaugeData" [options]="gaugeOpts" [type]="gaugeType"></canvas>
            <div class="gauge-center">
              <div class="gauge-value">{{ teacherLoginPercent }}%</div>
              <div class="gauge-caption">Teachers with at least<br>one login per week</div>
            </div>
          </div>
          <ol class="top-list">
            <li *ngFor="let school of topTeacherLogins">{{ school.value }} - {{ school.name }}</li>
          </ol>
        </div>
      </div>
    </div>

    <!-- Row: Student Engagement -->
    <div class="dashboard-card">
      <div class="card-head">
        <div class="card-title">Student Engagement</div>
        <div class="card-top-title student-color">Top Student Usage by School</div>
      </div>
      <div class="card-body student-engagement">
        <!-- Donut -->
        <div class="donut-wrapper">
          <div class="donut">
            <canvas baseChart [data]="donutData" [options]="donutOpts" [type]="donutType"></canvas>
          </div>
          <div class="donut-caption">Average Minutes / Week</div>
        </div>

        <!-- Key -->
        <div class="minutes-key">
          <div class="key-heading">Student Minutes per week</div>
          <div class="highlight-box">
            <div class="key-row">
              <div class="key-percent">{{ studentMinutePercents[0] }}%</div>
              <div class="key-swatch" style="background: #B2D235 ;"></div>
              <div class="key-label">80+ minutes</div>
            </div>
            <div class="key-row">
              <div class="key-percent">{{ studentMinutePercents[1] }}%</div>
              <div class="key-swatch" style="background: #0095DA ;"></div>
              <div class="key-label">60-79 minutes</div>
            </div>
            <div class="highlight-summary">
              <div class="highlight-percent">{{ studentsGetting60Plus }}%</div>
              <div class="highlight-label">Students getting 60 min or more</div>
            </div>
          </div>
          <div class="key-row">
            <div class="key-percent">{{ studentMinutePercents[2] }}%</div>
            <div class="key-swatch" style="background: #007236 ;"></div>
            <div class="key-label">40 - 59 minutes</div>
          </div>
          <div class="key-row">
            <div class="key-percent">{{ studentMinutePercents[3] }}%</div>
            <div class="key-swatch" style="background: #8CCEEE ;"></div>
            <div class="key-label">20 - 39 minutes</div>
          </div>
          <div class="key-row">
            <div class="key-percent">{{ studentMinutePercents[4] }}%</div>
            <div class="key-swatch" style="background: #555555 ;"></div>
            <div class="key-label">0 - 19 minutes</div>
          </div>
        </div>

        <!-- Top student usage by school -->
        <ol class="top-list student">
          <li *ngFor="let school of topStudentUsage">{{ school.value }}% - {{ school.name }}</li>
        </ol>
      </div>

      <!-- Student Units -->
      <div class="student-units">
        <div class="units-count">
          <div class="units-value">{{ studentUnitsCount }}</div>
          <div class="units-label">Students</div>
        </div>
        <div class="units-bar-wrapper">
          <div class="units-title">Student Units</div>
          <div class="units-bar">
            <div class="units-bar-fill" [style.width.%]="studentUnitsPercent"></div>
          </div>
          <div class="units-caption">Students getting at least one unit per week</div>
        </div>
      </div>
    </div>
  </div>
</wf-district-report-container>
